<template>
  <span class='m-0 p-0' v-if=!!html>
    <span v-if="!hide">
      <a v-if="linkHref" :href="linkHref" :target="linkTarget">
        <span :style="`color:${showWarning && different ? 'red' : 'default'}`" v-html=html />
      </a>
      <router-link v-else-if="linkTo" :to="linkTo" :target="linkTarget">
        <span :style="`color:${showWarning && different ? 'red' : 'default'}`" v-html=html />
      </router-link>
      <span v-else :style="`color:${showWarning && different ? 'red' : 'default'}`" v-html=html />
    </span>
    <a href="#" v-if="copyButton" v-b-popover.hover="'Click to Copy'" @click='copyToClipboard(value)'>
      <i class='fas fa-clipboard'></i>
    </a>
    <b-button variant="link" class='m-0 p-0' v-if="showWarning && different" @click="toggle" v-b-popover.hover=hoverText>
      <i class="fas fa-exclamation-circle"></i>
    </b-button>

    <b-modal id='comparison' ref='comparison' hide-footer v-if=modal :title=title>
      <div v-for="key in keys" :key="key.k" class='side-border'>
        <h5>{{key.label}}</h5>
        <p v-html="formatData(dict[key.k])" />
      </div>
    </b-modal>
    <div v-if="show && !modal">
      <div v-for="key in keys" :key="key.k" class='side-border'>
        <h5>{{key.label}}</h5>
        <p v-html="formatData(dict[key.k])" />
      </div>
    </div>
  </span>
</template>

<script>
import utility from '../../helpers/utility'
import orderMerge from '../../services/orderMerge'

export default {
  data() {
    return {
      show: false,
    };
  },
  props: {
    dict: { required: true, default: () => {} },
    modal: { type: Boolean, required: false, default: true },
    formatter: { type: String, required: false, default: undefined },
    tag: { type: String, required: false, default: undefined },
    copyButton: { type: Boolean, default: false },
    showWarning: { type: Boolean, default: true },
    title: { type: String },
    hide: { type: Boolean, default: false },
    fuzzy: { type: Boolean, default: false },
    linkTarget: { type: String, default: null },
    linkHref: { type: String, default: null },
    linkTo: { type: Object, default: null }
  },
  computed: {
    different() {
      return orderMerge.fieldDiffers(this.dict, this.fuzzy)
    },
    html() {
      if (typeof(this.tag) === 'undefined') {
        return `${this.value}`
      } else {
        return `<${this.tag}>${this.value}</${this.tag}>`
      }
    },
    value() {
      let value = orderMerge.mergeField(this.dict)
      return this.formatData(value)
    },
    filter(value) {
      if (typeof(this.formatter) === 'undefined') {
        return value
      } else {
        return (this.$options.filters[this.formatter])
      }
    },
    keys() {
      if (typeof(this.dict) === 'undefined') return []
      return Object.
        keys(this.dict).
        filter(x => x != 'different' && x != 'value').
        map(x => ({ k: x, label: utility.toUpper(x) }))
    },
    hoverText() {
      if (this.keys.length !== 2) {
        return `This data only exists in ${this.keys[0].label}!`
      } else {
        return `${this.keys[0].label} and ${this.keys[1].label} are different!!`
      }
    },
  },
  methods: {
    toggle() {
      this.show = !this.show;
      if (this.modal) {
        this.$refs['comparison'].show()
      }
    },
    formatData(value) {
      if (typeof(this.filter) === 'function') {
        return (this.filter)(value)
      } else {
        return value
      }
    },
    copyToClipboard(text) {
      if (window.clipboardData && window.clipboardData.setData) {
        // IE specific code path to prevent textarea being shown while dialog is visible.
        return clipboardData.setData("Text", text);
      } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
          return document.execCommand("copy");  // Security exception may be thrown by some browsers.
        } catch (ex) {
          console.warn("Copy to clipboard failed.", ex);
          return false;
        } finally {
          document.body.removeChild(textarea);
        }
      }
    },
  }
};
</script>

<style>
.side-border {
  border-left: 2px solid #007bff;
  padding-left: 6px;
}
.btn-link {
  color: #dc3545;
}
</style>



// WEBPACK FOOTER //
// src/components/utility/DataMerger.vue